<script setup lang="ts">
import { computed } from 'vue';
import Dialog from 'primevue/dialog';
import OwnersForm from '@/components/forms/OwnersForm.vue';
import { UserResponseDto } from '@clearbanc/baus-sdk';
import { useStore } from 'vuex';
import { useUserManagement } from '@/composables/user-management';
import TeamEditOtherUserForm from './TeamEditOtherUserForm.vue';

// -----
// Props & Emits
// -----
const props = defineProps<{
  visible: boolean;
  userToEdit?: UserResponseDto;
}>();

const emit = defineEmits<{
  closeModal: [];
  saveSuccess: [userId: string];
}>();

// -----
// Setup
// -----
const store = useStore();

// -----
// Computed
// -----
const businessCorpCountry = computed(() => store.getters.businessCorpCountry);
const currentUserId = computed(() => props.userToEdit?.id);

const { isAuthenticatedUser } = useUserManagement(currentUserId);

// -----
// Methods
// -----
const closeModal = () => {
  emit('closeModal');
};

const handleSaveSuccess = async () => {
  if (props.userToEdit?.id) {
    emit('saveSuccess', props.userToEdit.id);
  }
};
</script>

<template>
  <Dialog
    :visible="props.visible"
    header="Edit User Profile"
    :modal="true"
    :closable="true"
    :closeOnEscape="false"
    @update:visible="closeModal"
    style="width: 80vw; max-width: 900px"
  >
    <div style="padding: 1.5rem">
      <OwnersForm
        v-if="props.userToEdit && isAuthenticatedUser"
        :key="props.userToEdit.id"
        :selected-owner="props.userToEdit"
        :business-corp-country="businessCorpCountry"
        remove-container
        @saveSuccess="handleSaveSuccess"
      />
      <TeamEditOtherUserForm
        v-else-if="props.userToEdit && !isAuthenticatedUser"
        :user="props.userToEdit"
        @saveSuccess="handleSaveSuccess"
      />
    </div>
  </Dialog>
</template>
